export default "__VITE_ASSET__Bt3l6HDV__"